module.exports = __webpack_public_path__ + "static/media/apng_elvira.f3beea75.png";